import { findIndex } from 'lodash';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

export const addressStore = [
  {
    _id: 1,
    label: 'Hà Nội',
    city: 'Trung tâm bảo hành số 1',
    slug: 'ha-noi',
    store: [
      {
        address: 'Toà D, Chung cư Báo Nhân Dân, P. Xuân Phương, TP. Hà Nội',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.045591750221!2d105.74971107599858!3d21.03086168770508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31345490d9ac2053%3A0xb12ec446155f4102!2zVMOyYSBEIENodW5nIGPGsCBCw6FvIE5ow6JuIETDom4gWHXDom4gUGjGsMahbmc!5e0!3m2!1svi!2s!4v1715136328017!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      },
    ],
  },
  {
    _id: 2,
    label: 'Hà Nội',
    city: 'Trung tâm bảo hành số 2',
    slug: 'ha-noi-2',
    store: [
      {
        address: '186 Sài Đồng, P. Phúc Lợi, TP. Hà Nội',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d465.48048108110277!2d105.91370450987671!3d21.038933119440482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135a9a1e584d811%3A0xd8d117f3e4d018b7!2zQ8O0bmcgdHkgQ-G7lSBwaOG6p24gQ8O0bmcgbmdo4buHIEjhu6NwIExvbmc!5e0!3m2!1svi!2s!4v1782182299613!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>',
      },
    ],
  },
  {
    _id: 3,
    label: 'Hồ Chí Minh',
    city: 'Trung tâm bảo hành số 3',
    slug: 'ho-chi-minh',
    store: [
      {
        address: '55 Minh Phụng, P. Đông Hưng Thuận, TP. Hồ Chí Minh',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d979.6879448402551!2d106.61892116959193!3d10.830298116549894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752baf712246bd%3A0x1c4e6a3ea81159!2sGiga.vn!5e0!3m2!1svi!2s!4v1775815959212!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>',
      },
    ],
  },
  {
    _id: 4,
    label: 'Đà Nẵng',
    city: 'Trung tâm bảo hành số 4 (Chỉ áp dụng cho Robot Ecovacs)',
    slug: 'da-nang',
    store: [
      {
        address: '35 Chu Mạnh Trinh, P. Cẩm Lệ, TP. Đà Nẵng',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3834.596930296155!2d108.20823588469642!3d16.034484500779126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x314219e24c4af535%3A0x7d4c2e80e4dedb83!2zQ8O0bmcgdHkgQ-G7lSBwaOG6p24gQ8O0bmcgbmdo4buHIEjhu6NwIExvbmc!5e0!3m2!1svi!2s!4v1709880460955!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      },
    ],
  },
  {
    _id: 5,
    label: 'Hải Phòng',
    city: 'Trung tâm bảo hành số 5',
    slug: 'hai-phong',
    store: [
      {
        address: 'Số 23, BS1 Khu Đô thị PG, P. An Hải, TP. Hải Phòng',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3727.0!2d106.69!3d20.86!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDUxJzM2LjAiTiAxMDbCsDQxJzI0LjAiRQ!5e0!3m2!1svi!2s!4v1715136328017!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      },
    ],
  },
  {
    _id: 6,
    label: 'Thanh Hóa',
    city: 'Trung tâm bảo hành số 6',
    slug: 'thanh-hoa',
    store: [
      {
        address: 'Km330+445 đường tránh TP, Phường Quảng Phú, Thanh Hóa',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2241.57364848742!2d105.78626238219029!3d19.768025154478543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDQ2JzA0LjYiTiAxMDXCsDQ3JzE2LjEiRQ!5e1!3m2!1svi!2s!4v1790682585169!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>',
      },
    ],
  },
];

const TramBaoHanh = () => {
  const { slug } = useParams();

  const [address, setAddress] = useState(addressStore[0].store[0]);

  const [cityBranch, setCityBranch] = useState(addressStore[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    findIndex(addressStore, function (item) {
      if (item.slug == slug) {
        setCityBranch(item);
      }
    });
  }, [slug]);

  useEffect(() => {
    setAddress(cityBranch.store[0]);
  }, [cityBranch]);

  return (
    <div className="tram-bao-hanh container">
      <div className="title text-center">
        <h4 className="text-primary mb-0 py-3">
          <strong>TRUNG TÂM BẢO HÀNH</strong>
        </h4>
      </div>
      <div className="content">
        <div className="content-info">
          {addressStore.map((item, index) => (
            <div key={index} className="d-block item-list-map">
              <p>
                <strong>{item.city}</strong>
              </p>
              {item.store.map((element, index1) => (
                <div className="d-flex align-items-center justify-content-between">
                  <p key={index1}>
                    <i className="fa fa-map-marker text-primary float-left mr-10"></i>
                    <span className="d-flex" dangerouslySetInnerHTML={{ __html: element.address.replace(/\n/g, '<br />') }}></span>
                  </p>
                  <button type="button" className="text-primary border-0 bg-transparent" onClick={() => setAddress(element)}>
                    Xem bản đồ
                  </button>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="vertical-line"></div>
        <div className="content-map">{address != '' && <p>{ReactHtmlParser(address && address.map)}</p>}</div>
      </div>
    </div>
  );
};

export default TramBaoHanh;
